import styled, { css } from 'styled-components/macro';
import { Button, Checkbox } from '@redislabsdev/redis-ui-components';
import { FullHeightForm as FullHeightFormCommonStyle } from '../../../../../../utils/style';

export const Container = styled.div`
  scroll-behavior: smooth;
  display: flex;
  flex-flow: column;
`;

export const AgreeCheckbox = styled(Checkbox)<{ error?: string; name?: string }>`
  display: inline-flex;
  vertical-align: text-top;
  margin: 0;
`;

export const InlineInputsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  max-width: 40rem;
`;

export const InlineTerms = styled.span`
  display: inline-flex;
  gap: 0.3em;
  align-items: center;
  margin-left: 0.6rem;
  color: ${({ theme }) =>
    theme.appComponents.login.components.signUp.components.signUpForm.inlineTerms.color};
`;

export const FormSide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const bigTitleRules = css`
  font-size: 2.8rem;
  color: ${({ theme }) =>
    theme.appComponents.login.components.signUp.components.signUpForm.bigTitleRules.color};
  font-weight: ${({ theme }) => theme.core.font.fontWeight.semiBold};
  padding-bottom: 4rem;
`;
export const FormTitle = styled.div<{ paddingBottom?: string }>`
  ${bigTitleRules};
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  word-break: normal;
  ${({ paddingBottom }) => paddingBottom && `padding-bottom: ${paddingBottom}`};

  & hr {
    background-color: ${({ theme }) =>
      theme.appComponents.login.components.signUp.components.signUpForm.formTitle.color};
    width: 100%;
    height: 1px;
    margin-right: 3.5rem;

    &:last-of-type {
      margin-right: 0;
      margin-left: 3.5rem;
    }
  }
`;

export const FormWrapper = styled.div`
  justify-content: center;

  & form {
    display: flex;
    flex-direction: column;
  }

  & label {
    display: block;
    padding-top: 1.8rem;
  }
`;

export const SubmitButton = styled(Button)`
  display: block;
  align-self: flex-end;
  margin-top: 4.5rem;
`;

export const FullHeightForm = styled(FullHeightFormCommonStyle)`
  height: auto;
`;
